import { BUSINESS } from "../lib/site";

const ITEMS = [
    "SAME-WEEK GUARANTEE",
    "POPLAR BLUFF + 30 MILES",
    'GROUND 6–8" BELOW GRADE',
    "FULL CLEANUP AVAILABLE",
    "CASH • CARD • VENMO • PAYPAL • SQUARE",
    BUSINESS.hours.toUpperCase(),
    "SAME-WEEK GUARANTEE",
    "POPLAR BLUFF + 30 MILES",
    'GROUND 6–8" BELOW GRADE',
    "FULL CLEANUP AVAILABLE",
    "CASH • CARD • VENMO • PAYPAL • SQUARE",
    BUSINESS.hours.toUpperCase(),
];

const Marquee = () => (
    <div
        className="relative overflow-hidden border-y border-brand-line bg-brand-surface py-4"
        data-testid="editorial-marquee"
    >
        <div className="marquee-track flex w-max whitespace-nowrap">
            {[0, 1].map((half) => (
                <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
                    {ITEMS.slice(half === 0 ? 0 : 6, half === 0 ? 6 : 12).map((item, i) => (
                        <span
                            key={`${half}-${i}`}
                            className="inline-flex items-center font-display font-bold uppercase text-lg tracking-wide text-brand-cream"
                        >
                            <span className="px-6">{item}</span>
                            <span className="text-brand-amber">•</span>
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default Marquee;
